export async function retry<T>(
  fn: () => Promise<T>,
  maxAttempts: number,
  shouldRetry: (error: unknown) => boolean = () => true,
): Promise<T> {
  let lastError: unknown;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (!shouldRetry(error)) break;
    }
  }
  throw lastError;
}
